import { Box, BoxProps } from '@air/zephyr';

export interface BoldProps extends BoxProps<'b'> {}

export const Bold = ({ tx, ...restOfProps }: BoldProps) => {
  return <Box as="strong" {...restOfProps} tx={{ fontWeight: 'semibold', ...tx }} />;
};
